import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import React from "react";

const useStyles = makeStyles(() => ({
  separator: {
    height: 16
  }
}));

const MarkdownHelpDialog = ({ isOpen, onClose }) => {
  const classes = useStyles();
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <Typography>
          Kirs uses Markdown for formatting. The preview shows the formatted
          text and is what users will see in Kirs Officer. Here's the syntax
          used to bold and/or highlight your text:
        </Typography>
        <div className={classes.separator} />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableCell>Style</TableCell>
              <TableCell>Syntax</TableCell>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Bold</TableCell>
                <TableCell>**bold text**</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Highlight</TableCell>
                <TableCell>`highlight text`</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
};

export default MarkdownHelpDialog;
